import { useContext } from 'react';
import { CampaignEditorContext } from '../../context/CampaignEditorContext/context';

function useCampaignEditor() {
  const ctx = useContext(CampaignEditorContext);
  if (!ctx) {
    throw new Error(
      'useCampaignEditor must be used inside a CampaignEditorProvider',
    );
  }
  return ctx;
}

export default useCampaignEditor;
